import React, {useRef, useState} from 'react'
import PreferenceQuestionnaire from "./components/PreferenceQuestionnaire";
import PreferenceRatings from "./components/PreferenceRatings";
import PageNotAllowed from '../../components/errors/PageNotAllowed';
import {useAuth} from "../../providers/AuthProvider";
import ReactDOM from "react-dom";
import User from "../../models/User";
import WorkPreferencesForm from "./components/WorkPreferencesForm";

const WorkPreferences = (props) => {
    const formRef = useRef(null);


    const {auth, talentUpdate} = useAuth();
    const [isDisabled, setIsDisabled] = useState(false);
    const [preferences, setPreferences] = useState(auth?.talentPreferences())
    const [currentPage, setCurrentPage] = useState(1)

    const validateForm = async() => {
        let invalid = false;
        if (formRef.current) {
            invalid = await formRef.current.invalidFields();
            if (invalid) {
                const node = ReactDOM.findDOMNode(invalid);

                $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
            }
        }
        return !invalid
    }
    const submitPreferences = async() => {
        await setIsDisabled(true)

        let validatedForm = await validateForm();

        if (!validatedForm) {
            await setIsDisabled(false)

            return;
        }

        try {

            let fields = [
                'can_travel_for_work',
                'talent_commitment_level',
                'available_hours_per_week',
                'has_full_time_employment_interest',
                // 'has_contract_to_hire_interest',
                'can_travel_for_work',
                'is_available',
            ]

            if (preferences.can_travel_for_work) {
                fields.push('max_travel_distance', 'travel_days_per_week', 'max_travel_distance_units')
            }
            fields.push('prefers_any_non_us_timezone', 'prefers_any_timezone',)

            let workPreferenceRatings = User.TalentWorkPreferences;

            workPreferenceRatings = TB.reduce(workPreferenceRatings, (result, rating) => {
                result[rating] = parseInt(preferences.talent_work_preferences?.[rating]) || 1;
                return result;
            }, {})

            let allTimeZones = Object.values({...laravel.talent_questions.time_zones});

            let timeZonePrefs = [];
            for (let timeZone of allTimeZones) {
                if (preferences.prefers_any_timezone
                    || preferences.time_zones?.includes(timeZone.id)) {
                    timeZonePrefs.push(timeZone.id);
                }
            }


            let updates = TB.pick(preferences, [...fields]);

            let formattedPreferences = {
                ...updates,
                time_zones: timeZonePrefs,
                talent_work_preferences: {...workPreferenceRatings}
            }
            formattedPreferences.can_travel_for_work = formattedPreferences.can_travel_for_work ? 1 : 0;
            formattedPreferences.has_full_time_employment_interest = formattedPreferences.has_full_time_employment_interest ? 1 : 0;

            console.log('submitPreferences', formattedPreferences);

            let updatedAuth = await talentUpdate(formattedPreferences).catch(console.warn);
            await setIsDisabled(false);

            if (updatedAuth) {

                await setPreferences(updatedAuth.talentPreferences());

                TB.sysAlert('talent.work_preferences_updated');
                return true;

            } else {

                await TB.showServerErrorToast();
                return false;
            }
        }catch (e) {
            console.warn(e);
            await setIsDisabled(false);
            await TB.showServerErrorToast();
        }



    }


    if (auth?.isTalentSupplierResource()) {
        return <PageNotAllowed redirect="/talent/dashboard" />
    }

    let showGraphic = TB.platformHasImage('Asset_Talent_Work_Preferences_Graphic');

    return (
        <>
        {/* <div className='talent-portal-container'>
            <div className='talent-portal-page-container p-4 md:p-8'>
                <h3 className="mb-0 text-2xl">
                    Update your work preferences
                </h3>
                <div className='talent-preferences-panel'>
                    <div className="row no-gutters flex flex-wrap">
                        <div className={showGraphic ? "md:w-8/12" : "w-full"}>
                            {currentPage === 1 && (
                                <PreferenceQuestionnaire
                                    ref={formRef}
                                    disabled={isDisabled}
                                    preferences={preferences}
                                    onChange={setPreferences}
                                />
                            )}
                            {currentPage === 2 && (
                                <PreferenceRatings
                                    ref={formRef}
                                    disabled={isDisabled}
                                    preferences={preferences}
                                    onChange={setPreferences}
                                />
                            )}
                            <div className="flex work-preferences-actions">
                                {currentPage === 2 && (
                                    <button
                                        onClick={async () => {
                                            await setPreferences(auth?.talentPreferences());
                                            return setCurrentPage(1)
                                        }}
                                        disabled={isDisabled}
                                        className="btn btn-outline-dark">
                                        Back
                                    </button>
                                )}
                                <button
                                    onClick={async () => {
                                        let submitted = await submitPreferences();
                                        if (submitted && currentPage === 1) {
                                            setCurrentPage(2)
                                        }
                                    }}
                                    disabled={isDisabled}
                                    className="btn btn-primary">
                                    {currentPage === 1 ? 'Next' : 'Save Updates'}
                                </button>
                            </div>
                        </div>
                        {showGraphic && (
                            <div className="md:w-4/12 flex w-full items-start">
                                <div className="flex flex-col items-stretch justify-start flex-1 p-4">
                                    <img src={laravel.platform_settings.Asset_Talent_Work_Preferences_Graphic}
                                         className="w-100" />
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div> */}

        {/* ADD NEW STUFF HERE  */}
        <WorkPreferencesForm/>
        </>

    );
}

WorkPreferences.path = '/work-preferences';

export default WorkPreferences;